import React from 'react'
import { FormattedMessage } from 'react-intl'
import { LOAN_TERM_MESSAGES } from '../../../../../constants/loan'
import { baseProps } from './Shapes'

const LoanName = ({ type, years }) => (
  <FormattedMessage
    {...LOAN_TERM_MESSAGES[type.toLowerCase()]}
    values={{ years }}
  />
)

LoanName.propTypes = {
  ...baseProps,
}

export default LoanName
